import React from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import {utils,writeFileXLSX} from 'xlsx';

import {ChangeDateStringOnlyDate,ChangeMobileFormat,clearCheckedLists,AddOptionToString} from "../../../components/common/Common";

function StaffSearchResult({varMaxNumPage,varStaffLists,setStaffLists,getStaffList}) {

  //목록의 모든 항목 선택하기
  const onCheckedAll = (e) => {
    const bChecked = Number(e.currentTarget.checked);
    clearCheckedLists(bChecked);
    //배열값 변경
    let copyDatas = [...varStaffLists];
    for (var i=0; i < copyDatas.length; i++) {
      copyDatas[i].checked = bChecked;
    }
    setStaffLists(copyDatas);
  } 

  //목록상의 항목 선택하기
  const onCheckItemHandler = (e,mem_idx) => {
    const bChecked = Number(e.currentTarget.checked);
    const findIndex = varStaffLists.findIndex(element=>element.mem_idx===mem_idx);
    let copyLists = [...varStaffLists];
    copyLists[findIndex].checked = bChecked;
    setStaffLists(copyLists);
    CheckAllButtonState();
  }

  const CheckAllButtonState = () => {
    //전체버튼 점검
    let bchecked = true;
    const delItems = document.querySelectorAll('.del-item');
    for(var i=0; i < delItems.length; i++) {
      if(delItems[i].checked === false) {
        bchecked = false;
        break;
      }
    }
    const chkallItem = document.getElementById('deleteItems');
    chkallItem.checked = bchecked;
  } 

  //엑셀 다운로드
  const onDownloadExcelHandler = (e) => {
    let titleArray = {번호:'',아이디:'',이름:'',소속:'',직위:'',연락처:'',등록일:'',이메일:'',은행명:'',계좌번호:'',예금주:''}; 
    const dataArray = varStaffLists.filter(el=>el.checked === 1);
    if(dataArray?.length === 0) {
      alert('엑셀파일로 다운로드할 항목들을 먼저 선택하세요.'); return false;
    }
    if(!window.confirm('Excel 파일로 다운로드합니까?')) return false;

    let excelList = [];
    for(var i=0; i < dataArray.length; i++) {
      var lineObj = dataArray[i];
      var newExcelObj = {...titleArray};
      newExcelObj['번호'] = varMaxNumPage - i;
      newExcelObj['아이디'] = lineObj.mem_id;
      newExcelObj['이름'] = lineObj.mem_name;
      newExcelObj['소속'] = lineObj.vd_name;
      newExcelObj['직위'] = lineObj.vp_name;
      newExcelObj['연락처'] = ChangeMobileFormat(lineObj.mem_mobile);
      newExcelObj['등록일'] = ChangeDateStringOnlyDate(lineObj.mem_rdate);
      newExcelObj['이메일'] = lineObj.mem_email;
      newExcelObj['은행명'] = lineObj.bl_name;
      newExcelObj['계좌번호'] = lineObj.st_account;
      newExcelObj['예금주'] = lineObj.st_owner;
      excelList.push(newExcelObj);
    }

    const ws = utils.json_to_sheet(excelList);
    const wb = utils.book_new();
    utils.book_append_sheet(wb,ws,'직원현황');
    writeFileXLSX(wb,'더나은물류-직원현황관리.xlsx');
    clearCheckedLists(false);
  }

  //선택 항목 삭제
  const onDeleteStaffList = async(e) => {
    e.preventDefault();
    //삭제하기위해 선택된 항목 알아내기
    let delitems = 0;
    let boardIndexString = "";
    varStaffLists.map(element=>{
      if(element.checked) {
        delitems++;
        boardIndexString = AddOptionToString(element.mem_idx,boardIndexString,',');
      }
      return "";
    });

    if (delitems === 0) {
      alert("삭제할 정보가 선택되어 있지 않습니다.");
      return;
    }
    if (!window.confirm(delitems + "개의 선택된 정보를 삭제합니까?")) return;

    const sendData = {delitems: boardIndexString};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_delete_staff_list`, sendData).then((res) => {
      if (res.data.retvalue === 1) {
        clearCheckedLists(false);
        getStaffList();
      } else {
        alert(res.data.message);
      }
    });
  };

  return (
    <>
      <div className="main-box" style={{marginTop:"30px"}}>
        <div className="btn-right">
          <Link to={`/Admin/StaffDetail/0`} className="btn-danger">직원등록</Link>
          {varStaffLists?.length>0?<button onClick={(e)=>onDeleteStaffList(e)} className="btn line black">삭제</button>:null}
          <button onClick={(e)=>onDownloadExcelHandler(e)} className="btn line">EXCEL 다운로드</button>
        </div>
        <table className="list">
          <colgroup>
            <col style={{width:"5%"}} />
            <col style={{width:"5%"}} />
            <col style={{width:"10%"}} />
            <col style={{width:"10%"}} />
            <col style={{width:"20%"}} />
            <col style={{width:"10%"}} />
            <col style={{width:"15%"}} />
            <col style={{width:"15%"}} />
            <col style={{width:"10%"}} />
          </colgroup>
          <thead>
            <tr>
              <th className="board-list"><input type="checkbox" id="deleteItems" onChange={(e)=>onCheckedAll(e)}/></th>
              <th>번호</th>
              <th>아이디</th>
              <th>이름</th>
              <th>소속</th>
              <th>직위</th>
              <th>연락처</th>
              <th>등록일</th>
              <th>상세</th>
            </tr>
          </thead>
          <tbody>
            {varStaffLists?.length === 0? 
              <tr>
                <td colSpan={9}>등록된 직원이 없습니다.</td>
              </tr>
            :
            varStaffLists.map((staff, i) => (
              <tr key={'staff_'+staff.mem_idx}>
                <td className="board-list">
                  <input type="checkbox" className={"del-item"} id={"deleteItem_" + staff.mem_idx} onChange={(e)=>onCheckItemHandler(e,staff.mem_idx)}/>
                </td>
                <td>{varMaxNumPage - i}</td>
                <td className="ellipsis">{staff.mem_id}</td>
                <td className="ellipsis">{staff.mem_name}</td>
                <td className="ellipsis">{staff.vd_name}</td>
                <td className="ellipsis">{staff.vp_name}</td>
                <td className="ellipsis">{ChangeMobileFormat(staff.mem_mobile)}</td>
                <td className="ellipsis">{ChangeDateStringOnlyDate(staff.mem_rdate)}</td>
                <td><Link to={`/Admin/StaffDetail/${staff.mem_idx}`} style={{width:"70px"}} className="btn line black">상세</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default StaffSearchResult;